import walletFinancialPositionsMessages from '../../../../messages/wallet/wallet-financial-positions.messages';
import { Column } from '../../../column';
import { LiquidityProduct } from '../../liquidity-macro-category';

export const mobileLiquidityColumns: Column<LiquidityProduct>[] = [
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderProduct,
    key: 'productName',
    type: 'string',
  },
  {
    headerLabel:
      walletFinancialPositionsMessages.tableHeaderAvailableBalanceShort,
    key: 'availableBalance',
    type: 'amount',
  },
];
